<h2>
  {{ translationService.getCountryRecyclabilityText() }}
</h2>
@if (countryRecyclability.length) {
  <mat-nav-list>
    @for (
      recyclability of countryRecyclability;
      track recyclability;
      let i = $index;
      let last = $last
    ) {
      <a
        mat-list-item
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
      >
        <span matListItemTitle>
          <span class="bold">{{ recyclability.country }}:</span>
          {{ recyclability.recyclabilityStatus }}
        </span>
      </a>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
} @else {
  <span>{{ translationService.getNaText() }}</span>
}
